export const GET_GENRES = 'genres/allGenres/get';
export const GET_GENRE_BY_ID = 'genres/genreById/get';
export const GET_GENRE_BY_SLUG = 'genres/genreBySlug/get';